<template>
  <div
    id="kt_content_container"
    class="d-flex flex-column-fluid align-items-start container-xxl"
  >
    <!-- <vue-webrtc ref="webrtc" width="100%" roomId="sample-room"> </vue-webrtc> -->
    <!--begin::Post-->
    <div class="content flex-row-fluid" id="kt_content">
      <!--begin::Table-->
      <div class="card card-flush mt-6 mt-xl-9">
        <!--begin::Card header-->
        <div class="card-header mt-5">
          <!--begin::Card title-->
          <div class="card-title flex-column">
            <h3 class="fw-bolder mb-1">En yakın randevum</h3>
          </div>
          <!--begin::Card title-->
        </div>
        <!--end::Card header-->
        <!--begin::Card body-->
        <div class="card-body pt-0">
          <!--begin::Table container-->
          <div class="table-responsive">
            <!--begin::Table-->
            <div
              id="kt_profile_overview_table_wrapper"
              class="dataTables_wrapper dt-bootstrap4 no-footer"
            >
              <div class="table-responsive">
                <table
                  id="kt_profile_overview_table"
                  class="
                    table table-row-bordered table-row-dashed
                    gy-4
                    align-middle
                    fw-bolder
                    dataTable
                    no-footer
                  "
                >
                  <!--begin::Head-->
                  <thead class="fs-7 text-gray-400 text-uppercase">
                    <tr>
                      <th
                        class="min-w-250px sorting"
                        tabindex="0"
                        aria-controls="kt_profile_overview_table"
                        rowspan="1"
                        colspan="1"
                        aria-label="Manager: activate to sort column ascending"
                        style="width: 434.719px"
                      >
                        Psikolog
                      </th>
                      <th
                        class="min-w-150px sorting"
                        tabindex="0"
                        aria-controls="kt_profile_overview_table"
                        rowspan="1"
                        colspan="1"
                        aria-label="Date: activate to sort column ascending"
                        style="width: 268.039px"
                      >
                        Tarih
                      </th>
                      <th
                        class="min-w-90px sorting"
                        tabindex="0"
                        aria-controls="kt_profile_overview_table"
                        rowspan="1"
                        colspan="1"
                        aria-label="Status: activate to sort column ascending"
                        style="width: 178.633px"
                      >
                        Durum
                      </th>
                      <th
                        class="min-w-50px text-end sorting"
                        tabindex="0"
                        aria-controls="kt_profile_overview_table"
                        rowspan="1"
                        colspan="1"
                        aria-label="Details: activate to sort column ascending"
                        style="width: 117.406px"
                      ></th>
                    </tr>
                  </thead>
                  <!--end::Head-->
                  <!--begin::Body-->
                  <tbody class="fs-6" v-if="isLoaded && myNextReservation">
                    <tr class="odd">
                      <td>
                        <!--begin::User-->
                        <div class="d-flex align-items-center">
                          <!--begin::Wrapper-->
                          <div class="me-5 position-relative">
                            <!--begin::Avatar-->
                            <div class="symbol symbol-35px symbol-circle">
                              <img
                                alt="Pic"
                                :src="`https://www.terapikoltugu.app/storage/photos/${myNextReservation.photo}`"
                              />
                            </div>
                            <!--end::Avatar-->
                          </div>
                          <!--end::Wrapper-->
                          <!--begin::Info-->
                          <div
                            class="d-flex flex-column justify-content-center"
                          >
                            <router-link
                              class="fs-6 text-gray-800 text-hover-primary"
                              :to="{
                                name: 'psychologist',
                                params: { id: myNextReservation.expertId },
                              }"
                              v-slot="{ href, navigate, isActive }"
                            >
                              <a
                                :href="href"
                                :class="{ active: isActive }"
                                @click="navigate"
                              >
                                {{ myNextReservation.name }}
                              </a>
                            </router-link>
                            <div class="fw-bold text-gray-400">
                              {{ myNextReservation.email }}
                            </div>
                          </div>
                          <!--end::Info-->
                        </div>
                        <!--end::User-->
                      </td>
                      <td>
                        {{ myNextReservation.date }} -
                        {{ myNextReservation.time }}
                      </td>
                      <td>
                        <span
                          class="badge badge-light-success fw-bolder px-4 py-3"
                          :class="{
                            'badge-light-success': !myNextReservation.pass,
                            'badge-light-danger': myNextReservation.pass,
                          }"
                          >{{
                            `${
                              myNextReservation.pass ? "Tamamlandı" : "Yakında"
                            }`
                          }}</span
                        >
                      </td>
                      <td class="text-end">
                        <router-link
                          class="btn btn-light btn-sm"
                          :to="{
                            name: 'call',
                          }"
                          v-slot="{ href, navigate, isActive }"
                        >
                          <a
                            :href="href"
                            :class="{ active: isActive }"
                            @click="navigate"
                          >
                            Başlat
                          </a>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                  <!--end::Body-->
                </table>
              </div>
            </div>
            <!--end::Table-->
          </div>
          <!--end::Table container-->
        </div>
        <!--end::Card body-->
      </div>
      <div class="card card-flush mt-6 mt-xl-9">
        <!--begin::Card header-->
        <div class="card-header mt-5">
          <!--begin::Card title-->
          <div class="card-title flex-column">
            <h3 class="fw-bolder mb-1">Randevularım</h3>
          </div>
          <!--begin::Card title-->
        </div>
        <!--end::Card header-->
        <!--begin::Card body-->
        <div class="card-body pt-0">
          <!--begin::Table container-->
          <div class="table-responsive">
            <!--begin::Table-->
            <div
              id="kt_profile_overview_table_wrapper"
              class="dataTables_wrapper dt-bootstrap4 no-footer"
            >
              <div class="table-responsive">
                <table
                  id="kt_profile_overview_table"
                  class="
                    table table-row-bordered table-row-dashed
                    gy-4
                    align-middle
                    fw-bolder
                    dataTable
                    no-footer
                  "
                >
                  <!--begin::Head-->
                  <thead class="fs-7 text-gray-400 text-uppercase">
                    <tr>
                      <th
                        class="min-w-250px sorting"
                        tabindex="0"
                        aria-controls="kt_profile_overview_table"
                        rowspan="1"
                        colspan="1"
                        aria-label="Manager: activate to sort column ascending"
                        style="width: 434.719px"
                      >
                        Psikolog
                      </th>
                      <th
                        class="min-w-150px sorting"
                        tabindex="0"
                        aria-controls="kt_profile_overview_table"
                        rowspan="1"
                        colspan="1"
                        aria-label="Date: activate to sort column ascending"
                        style="width: 268.039px"
                      >
                        Tarih
                      </th>
                      <th
                        class="min-w-90px sorting"
                        tabindex="0"
                        aria-controls="kt_profile_overview_table"
                        rowspan="1"
                        colspan="1"
                        aria-label="Status: activate to sort column ascending"
                        style="width: 178.633px"
                      >
                        Durum
                      </th>
                      <th
                        class="min-w-50px text-end sorting"
                        tabindex="0"
                        aria-controls="kt_profile_overview_table"
                        rowspan="1"
                        colspan="1"
                        aria-label="Details: activate to sort column ascending"
                        style="width: 117.406px"
                      ></th>
                    </tr>
                  </thead>
                  <!--end::Head-->
                  <!--begin::Body-->
                  <tbody class="fs-6" v-if="isLoaded">
                    <tr
                      class="odd"
                      v-for="(item, index) in myReservations"
                      :key="`all-${index}`"
                    >
                      <td>
                        <!--begin::User-->
                        <div class="d-flex align-items-center">
                          <!--begin::Wrapper-->
                          <div class="me-5 position-relative">
                            <!--begin::Avatar-->
                            <div class="symbol symbol-35px symbol-circle">
                              <img
                                alt="Pic"
                                :src="`https://www.terapikoltugu.app/storage/photos/${item.photo}`"
                              />
                            </div>
                            <!--end::Avatar-->
                          </div>
                          <!--end::Wrapper-->
                          <!--begin::Info-->
                          <div
                            class="d-flex flex-column justify-content-center"
                          >
                            <router-link
                              class="fs-6 text-gray-800 text-hover-primary"
                              :to="{
                                name: 'psychologist',
                                params: { id: item.expertId },
                              }"
                              v-slot="{ href, navigate, isActive }"
                            >
                              <a
                                :href="href"
                                :class="{ active: isActive }"
                                @click="navigate"
                              >
                                {{ item.name }}
                              </a>
                            </router-link>
                            <div class="fw-bold text-gray-400">
                              {{ item.email }}
                            </div>
                          </div>
                          <!--end::Info-->
                        </div>
                        <!--end::User-->
                      </td>
                      <td>{{ item.date }} - {{ item.time }}</td>
                      <td>
                        <span
                          class="badge fw-bolder px-4 py-3"
                          :class="{
                            'badge-light-success': !item.pass,
                            'badge-light-danger': item.pass,
                          }"
                          >{{ `${item.pass ? "Tamamlandı" : "Yakında"}` }}</span
                        >
                      </td>
                      <td class="text-end">
                        <router-link
                          class="btn btn-light btn-sm"
                          :to="{
                            name: 'psychologist',
                            params: { id: item.expertId },
                          }"
                          v-slot="{ href, navigate, isActive }"
                        >
                          <a
                            :href="href"
                            :class="{ active: isActive }"
                            @click="navigate"
                          >
                            Psikolog
                          </a>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                  <!--end::Body-->
                </table>
              </div>
            </div>
            <!--end::Table-->
          </div>
          <!--end::Table container-->
        </div>
        <!--end::Card body-->
      </div>
      <!--end::Card-->
    </div>
    <!--end::Post-->
  </div>
</template>

<script>
import * as API from "@/services/";
import { makeDate } from "@/helpers";

export default {
  data() {
    return {
      token: this.$store.getters.getAccessToken,
      isLoaded: false,
      myNextReservation: null,
      myReservations: [],
    };
  },
  async created() {
    await this.getnextConsult();
    await this.getAllConsult();
  },
  methods: {
    getnextConsult: async function () {
      let vm = this;

      if (!vm.token) return;

      let response = await API.nextConsult(vm.token);

      if (response.data.id) {
        vm.myNextReservation = {
          id: response.data.id,
          name: `${response.data.dietitian_user.name} ${response.data.dietitian_user.surname}`,
          expertId: response.data.dietitian_user.id,
          email: response.data.dietitian_user.email,
          photo: response.data.dietitian_user.photo,
          date: makeDate(response.data.startTextIso),
          time: response.data.startText.split(" ")[1],
          pass: false,
        };
      }
    },
    getAllConsult: async function () {
      let vm = this;

      if (!vm.token) return;

      let response = await API.getAllConsult(vm.token);
      vm.myReservations = response.data.map((item) => {
        return {
          id: item.id,
          name: `${item.dietitian_user.name} ${item.dietitian_user.surname}`,
          expertId: item.dietitian_user.id,
          email: item.dietitian_user.email,
          photo: item.dietitian_user.photo,
          date: makeDate(item.startTextIso),
          time: item.startText.split(" ")[1],
          pass: new Date().getTime() > item.startTS * 1000 + 3600000,
        };
      });

      vm.isLoaded = true;
    },
  },
};
</script>